import { useCallback, useMemo } from 'react';

import { Company } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$types';
import { useSessionInfo } from '@store';
import { BaseSessionInfoCompany } from '@types';

import { useGetCurrentBreakpoint } from '../useGetCurrentBreakpoint';

export enum ExternalAbComponentsActionEnum {
	SHOW = 'show',
	HIDE = 'hide',
}

interface UseHandleExternalAbComponentsHookOutput {
	handleExternalAbComponents: (action: ExternalAbComponentsActionEnum) => void;
}

export const useHandleExternalAbComponents = (): UseHandleExternalAbComponentsHookOutput => {
	const { company } = useSessionInfo();
	const { currentView } = useGetCurrentBreakpoint();

	const isAbAndIsSmallView = useMemo(
		() => company === BaseSessionInfoCompany.AB && currentView === 'smallView',
		[company, currentView]
	);

	const isAbAndIsBigView = useMemo(
		() => company === BaseSessionInfoCompany.AB && currentView === 'bigView',
		[company, currentView]
	);

	const handleExternalAbComponents = useCallback(
		(action: ExternalAbComponentsActionEnum) => {
			// Lazily query the DOM only when the handler is called, not on render.
			const fixedCTA = document.getElementsByClassName('fixed-cta')[0] as HTMLDivElement;
			const headerBar = document.querySelector('header');

			const showFixedCTA = () => {
				if (fixedCTA) fixedCTA.style.zIndex = '1000';
			};
			const hideFixedCTA = () => {
				if (fixedCTA) fixedCTA.style.zIndex = 'unset';
			};
			const showHeaderBar = () => {
				if (headerBar) headerBar.style.zIndex = '1000';
			};
			const hideHeaderBar = () => {
				if (headerBar) headerBar.style.zIndex = 'unset';
			};

			if (isAbAndIsSmallView) {
				action === ExternalAbComponentsActionEnum.SHOW ? showFixedCTA() : hideFixedCTA();
			}

			if (isAbAndIsBigView) {
				action === ExternalAbComponentsActionEnum.SHOW ? showHeaderBar() : hideHeaderBar();
			}
		},
		[isAbAndIsSmallView, isAbAndIsBigView]
	);

	return {
		handleExternalAbComponents,
	};
};
